module.exports = __webpack_public_path__ + "img/22@2x.952f60e1.png";